// rm-animate.js
// IntersectionObserver-driven reveal animations.
// Targets elements with class ".rm-anim" or attribute [data-rm-anim].
// Supports:
//  - data-rm-anim="fade-up|fade-in|slide-up|blur-fade|reveal|none"
//  - data-rm-delay="120" (ms)
//  - data-rm-duration="650" (ms)
//  - data-rm-once="true|false" (default true)

(function () {
  const SELECTOR = '.rm-anim, [data-rm-anim]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseBool(v, defaultVal = true) {
    if (v === null || v === undefined || v === '') return defaultVal;
    return String(v).toLowerCase() === 'true';
  }

  function applyInlineTiming(el) {
    const delay = el.getAttribute('data-rm-delay');
    const duration = el.getAttribute('data-rm-duration');
    if (delay) el.style.transitionDelay = `${parseFloat(delay) || 0}ms`;
    if (duration) el.style.transitionDuration = `${Math.max(0, parseFloat(duration) || 0)}ms`;
  }

  function applyPresetClass(el) {
    const preset = (el.getAttribute('data-rm-anim') || '').trim();
    if (!preset) return;

    // If user uses data attr, we don't require class, but class-based presets are supported too.
    // For convenience, add a class that matches preset (optional; CSS already supports data attr).
    // Avoid duplicating if already present.
    const cls = `rm-anim--${preset}`;
    if (!el.classList.contains('rm-anim') && !el.hasAttribute('data-rm-anim')) return;

    // If preset is "none", force visible and exit early
    if (preset === 'none') {
      el.classList.add('is-visible');
      return;
    }

    // Add class only if element has .rm-anim (nice for debugging), but CSS works via data too.
    if (el.classList.contains('rm-anim')) {
      el.classList.add(cls);
    }
  }

  function show(el) {
    el.classList.add('is-visible');
  }

  function hide(el) {
    el.classList.remove('is-visible');
  }

  function init() {
    const els = Array.from(document.querySelectorAll(SELECTOR));
    if (!els.length) return;

    // Reduced motion: show everything
    if (prefersReducedMotion()) {
      els.forEach((el) => show(el));
      return;
    }

    // Prepare elements
    els.forEach((el) => {
      const preset = (el.getAttribute('data-rm-anim') || '').trim();
      if (preset === 'none') {
        show(el);
        return;
      }
      applyInlineTiming(el);
      applyPresetClass(el);
    });

    // Fallback if IntersectionObserver missing
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => show(el));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;
          const once = parseBool(el.getAttribute('data-rm-once'), true);

          if (entry.isIntersecting) {
            show(el);
            if (once) io.unobserve(el);
          } else {
            if (!once) hide(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    els.forEach((el) => {
      const preset = (el.getAttribute('data-rm-anim') || '').trim();
      if (preset !== 'none') io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
